import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { IEmployee, ITeam } from '@signal/asp-data-commons';
import { Observable } from 'rxjs';
import * as fromEmployeeSelectors from '../../../store/employee/employee.selectors';

@Component({
  selector: 'app-txm-team-management',
  templateUrl: './txm-team-management.component.html',
  styleUrls: ['./txm-team-management.component.scss']
})
export class TxmTeamManagementComponent implements OnInit, OnChanges {
  @Input() team: ITeam;
  @Input() techniciansCount$: Observable<number>;
  @Input() isTxmTeam: boolean;
  @Input() isTeamCreated: boolean;

  employees$: Observable<IEmployee[]>;
  teamFlatRateHours$: Observable<number>;
  validTxmTeam$: Observable<boolean>;

  constructor(private employeeState: Store<IEmployee>) { }

  ngOnInit(): void {


  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.isTxmTeam?.currentValue || changes?.isTeamCreated?.currentValue) {
      this.setupStore();
    }
  }
  public setupStore() {
    const props = { employeeIds: this.team.employeeIds };
    this.employees$ = this.employeeState
      .select(fromEmployeeSelectors.selectEmployeesByIds, props);
      this.validTxmTeam$ = this.employeeState.select(fromEmployeeSelectors.selectValidTxmTeamByEmployeesIds, props)
    this.teamFlatRateHours$ = this.employeeState.select(fromEmployeeSelectors.selectFlatRateHoursByIds, props);
  }
}

